var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.512,
    height: 21.5,
    viewBox: "0 0 21.512 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #707070;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10205",
    "data-name": "Group 10205",
    transform: "translate(20442.75 2727.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7415",
    "data-name": "Path 7415",
    className: "cls-1",
    d: "M8.111,0C3.631,0,0,2.98,0,6.657a5.786,5.786,0,0,0,1.248,3.537v4.33l3.368-1.866a9.554,9.554,0,0,0,3.5.656c4.48,0,8.111-2.98,8.111-6.657S12.591,0,8.111,0Z",
    transform: "translate(-20442 -2726.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7416",
    "data-name": "Path 7416",
    className: "cls-1",
    d: "M6.576,14.3c-.129,0-.252-.022-.381-.025a9.31,9.31,0,0,0,4.748,1.236,10.241,10.241,0,0,0,1.631-.133l3.537,3.189,1.071-5.476h-.015s3.007-3.121-.138-6.045",
    transform: "translate(-20440.465 -2725.063)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.aa5ace72287990ff076dde7945d44ef2.svg";
export { ForwardRef as ReactComponent };